<template>
  <div id="app" class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
    <div @click="signOut()" class="power">
      <i style="cursor: pointer; font-size: 0.5rem" class="el-icon-back"></i>
    </div>
    <div class="otherReport">
      <img @click="d8Process()" style="height: 0.6rem" src="../../../../assets/img/fr/table.png" />
    </div>
    <div class="otherTime">
      <span style="margin-top:5px;">更新时间：{{ updateTimeText }}</span>
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <!-- <h3 class="title">快速反应跟踪</h3> -->
      <!--  <el-button class="title" type="primary">{{ title }}</el-button> -->
      <div class="font-big font-weight light-title">
        {{ title ? title : "8D统计看板" }}
      </div>
    </header>

    <div class="p w-25 h-30 flex">
      <!--问题关闭率-->
      <fr-issue-close-rate :beans="issueRateList"></fr-issue-close-rate>
    </div>
    <div class="p w-25 h-30 flex">
      <!--部门分布-->
      <fr-issue-dept :beans="issueDeptList"></fr-issue-dept>
    </div>
    <div class="p w-25 h-30 flex">
      <!--根本原因分布-->
      <fr-issue-cause :beans="causeRateList"></fr-issue-cause>
    </div>
    <div class="p w-25 h-30 flex">
      <!--当年月别的出勤率-->
      <fr-month-attend :beans="monthAttend"></fr-month-attend>
    </div>


    <div class="p w-25 h-30 flex">
      <!--来源-->
      <fr-issue-source :beans="issueSource"></fr-issue-source>
    </div>
    <div class="p w-25 h-30 flex">
      <!--位置-->
      <fr-issue-place :beans="programRateList"></fr-issue-place>
    </div>
    <div class="p w-25 h-30 flex">
      <!--供应商-->
      <fr-issue-supplier :beans="supplierRateList"></fr-issue-supplier>
    </div>
    <div class="p w-25 h-30 flex">
      <!--部门当月的出勤率-->
      <fr-dept-attend :beans="deptAttend"></fr-dept-attend>
    </div>
    <div class="p w-100 h-30 flex">
      <!--问题超时措施-->
      <fr-issue-Overdue :beans="issueList"></fr-issue-Overdue>
    </div>




  </div>
</template> 

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../../../router";
import format from "date-fns/format";
import frIssueCloseRate from "./component/issue-close-rate.vue";
import frIssueDept from "./component/issue-dept.vue";
import frIssueCause from "./component/issue-cause.vue";
import frIssuePlace from "./component/issue-place.vue";
import frIssueSource from "./component/issue-source.vue";
import frIssueSupplier from "./component/issue-supplier.vue";
import frIssueOverdue from "./component/issue-overdue.vue";
import frDeptAttend from "./component/dept-attend-rate.vue";
import frMonthAttend from "./component/month-attend-rate.vue";
export default {
  name: "App",
  components: {
    frIssueCloseRate,
    frIssueDept,
    frIssueCause,
    frIssuePlace,
    frIssueSource,
    frIssueSupplier,
    frIssueOverdue,
    frDeptAttend,
    frMonthAttend,
  },
  data() {
    return {
      websock: null,
      lockReconnect: false,
      reconnectData: null,
      isload: false,
      issueRateList: [], //问题关闭率
      issueDeptList: [], //责任部门问题
      issueSource: [], //问题来源
      monthAttend: [], //月度出勤
      deptAttend: [], //部门出勤
      issueList: [], //未关闭问题列表
      programRateList: [],//项目
      supplierRateList: [],//供应商
      causeRateList: [],//根本原因
      now: null,
      week: null,
      loading: null,
      logoSrc: "/assets/img/logo_light.png",
      title: "8D统计看板",
      productList: [],
      product: {},
      productUUID: null,
      updateTimeText: null,
    };
  },

  mounted() {
    this.webSocket();
    this.loadData();
    this.loadBoardTitle();
    // this.loadTemplateCategory();
    //钟表
    setInterval(this.clock, 1000);
  },
  created() {
    this.isload = true;
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  methods: {
    d8Process() {
      this.$router.push({
        path: "/fr/board",
        query: {
          key: this.$route.query.key,
        }
      });
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    signOut() {
      router.back();
    },
    loadProductLine() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadProductLine()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadTemplateCategory() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadTemplateCategory()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadBoardTitle() { 
      var user = localStorage.getItem("user_session");

      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },
    selectProduct(item) {
      this.product = item || {};
      this.productUUID = item ? item.uuid : null;
      this.isload = true;
      this.loadData();
    },
    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        this.startLoading();
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        var params = { processCategory: this.$route.query.key };

        API.getFrDataV(params)
          .then((res) => {
            this.isload = false;
            if (res.success === true) {
              this.issueDeptList = res["issueDept"];
              this.issueRateList = res["issueCount"];
              this.issueSource = res["issueSource"];
              this.monthAttend = res["monthAttend"];
              this.deptAttend = res["deptAttend"];
              this.issueList = res["dueTodoList"];
              this.programRateList = res["programList"];
              this.causeRateList = res["rootCauseList"];
              this.supplierRateList = res["supplierList"];

              var now = new Date();
              this.updateTimeText = format(now, "MM-dd HH:mm:ss");
            }
            this.endLoading();
          })
          .catch((error) => {
            console.log(error);
            this.endLoading();
          });
      }
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      if (http) {
        http += "/websocket/fr/issue/keep";
      } else {
        http = "https://demo.biqs.cn/websocket/fr/issue/keep";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("分层审核 socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("分层审核 socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log("分层审核 socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      console.log("socket 数据刷新");
      //刷新
      this.loadData();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
  },
};
</script>

<style>
.prductCategory {
  color: white;
  position: absolute;
  right: 25%;
  top: 20px;
  z-index: 999999;
}

.pagebg {
  background: url("../../../../assets/img/8dbg.png");
}

.p {
  padding: .13333rem;
}

.loads {
  background: #06164a;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

header {
  background: url("../../../../assets/img/head_bg.png");
  background-size: 100% 100%;
  position: relative;
  height: 50px;
}

/* 媒体查询  */
@media screen and (max-width: 1024px) {
  html {
    font-size: 42px !important;
  }
}

@media screen and (min-width: 1920px) {
  html {
    font-size: 80px !important;
  }
}

/* 主题色 */
.color-blue {
  color: #1fe9e8;
}

.color-gray {
  color: #cdeaf6;
}

.logoImg {
  position: absolute;
  left: 80px;
  top: 0px;
  font-size: 22px;
  z-index: 999;
}
</style>
<style scoped src='./board.css'></style>


// WEBPACK FOOTER //
// src/pages/fr/report/8d/board.vue